import {useScrollTrigger, Zoom, Box} from '@mui/material';
import {ArrowUp, GoUpIcon} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';

import {BoxProps} from '@jobseeker/lotus/foundations';

import type {Theme} from '@mui/material';

type ScrollToTopProps = {
  theme: Theme;
  style: BoxProps;
};

const ScrollToTop = ({
  theme,
  style = {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}: ScrollToTopProps) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 700,
  });

  const handleClick = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  return (
    <Zoom in={trigger}>
      <Box
        onClick={() => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              handleClick();
            }, 0);
          });
        }}
        sx={style}
      >
        <Image
          src={isAppIimjobs ? GoUpIcon : ArrowUp}
          alt="Go Up"
          title="Scroll Up"
          height={isAppIimjobs ? 48 : 90}
          width={isAppIimjobs ? 48 : 90}
        />
      </Box>
    </Zoom>
  );
};

export default ScrollToTop;
